// Module
var code = "<div> <ui-select ng-model=\"vm.model\" theme=\"bootstrap\"> <ui-select-match placeholder=\"{{'Select a Group'|translate}}\">{{$select.selected.uniqueName}}</ui-select-match> <ui-select-choices repeat=\"type.guid as type in vm.groups|filter:{name:$select.search}\"> {{type.uniqueName}} </ui-select-choices> </ui-select> </div>";
// Exports
module.exports = code;